import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { SmartLinkStatsSeriesPoint } from 'fym-shared/src/smartlinks/stats';
import { TypedMemo } from '../../common/types';
import { artistHomeMessages as messages } from './artistHomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole Home; each part uses its own slice of it */
import styles from './ArtistHome.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Views per day as bars, with the first and the last day under them (design a1). */
const SmartlinksDayBarsComponent: React.FC<{ series: SmartLinkStatsSeriesPoint[] }> = ({ series }) => {
  const intl = useIntl();

  const bars = useMemo(() => {
    const max = Math.max(1, ...series.map((point) => point.views));
    return series.map((point) => ({
      date: point.date,
      heightPct: Math.round((point.views / max) * 100),
      label: `${point.date}: ${point.views} / ${point.clicks}`,
    }));
  }, [series]);

  const first = series[0]?.date;
  const last = series[series.length - 1]?.date;
  const formatDay = (day: string) => intl.formatDate(day, { month: 'short', day: 'numeric', timeZone: 'UTC' });

  return (
    <div className={styles.chart}>
      <div className={styles.sectionKey}>{intl.formatMessage(messages.smartlinksPerDay)}</div>
      <div className={styles.bars}>
        {bars.map((bar) => (
          <span key={bar.date} className={styles.bar} style={{ height: `${bar.heightPct}%` }} title={bar.label} />
        ))}
      </div>
      {first !== undefined && last !== undefined && (
        <div className={styles.axis}>
          <span>{formatDay(first)}</span>
          <span>{formatDay(last)}</span>
        </div>
      )}
    </div>
  );
};

export const SmartlinksDayBars = TypedMemo(SmartlinksDayBarsComponent);
